import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { parseBBCode } from '../../../libraries/BBCode'
import { probeHanBanner } from './hanBanner'

const STATUS_SYMBOLS = {
  Guerra: '⚔',
  Paz: '☮',
  Tensión: '⚡',
  'Conflicto Interno': '⚡',
  Alianza: '◎',
  Neutral: '◈',
}

export default function HanArchivesHero({
  slug,
  name,
  tagline,
  territoryUrl,
  climate,
  territoryStatus,
  leaderName,
  leaderTitle,
}) {
  const [bannerUrl, setBannerUrl] = useState(null)
  const taglineHtml = tagline ? parseBBCode(tagline) : ''
  const statusSymbol = STATUS_SYMBOLS[territoryStatus] || '◈'

  useEffect(() => {
    let cancelled = false
    probeHanBanner(slug).then((url) => {
      if (!cancelled) setBannerUrl(url)
    })
    return () => {
      cancelled = true
    }
  }, [slug])

  const hasBanner = Boolean(bannerUrl)

  return (
    <header
      className={`han-archives-hero${hasBanner ? ' han-archives-hero--banner' : ' han-archives-hero--plain'}`}
    >
      {hasBanner ? (
        <>
          <div
            className="han-archives-hero__bg"
            style={{ backgroundImage: `url(${bannerUrl})` }}
            aria-hidden="true"
          />
          <div className="han-archives-hero__overlay" aria-hidden="true" />
        </>
      ) : null}

      <div className="han-archives-hero__content">
        <Link to={territoryUrl} className="han-archives-hero__back">
          <span aria-hidden="true">←</span> Volver al Han
        </Link>

        <div className="han-archives-hero__head">
          <span className="han-archives-hero__eyebrow">卷 · Archivos del Han</span>
          <h1 className="han-archives-hero__title">{name}</h1>

          {(territoryStatus || climate || leaderName) && (
            <ul className="han-archives-hero__meta">
              {territoryStatus ? (
                <li className="han-archives-hero__meta-item">
                  <span aria-hidden="true">{statusSymbol}</span>
                  {territoryStatus}
                </li>
              ) : null}
              {climate ? (
                <li className="han-archives-hero__meta-item">{climate}</li>
              ) : null}
              {leaderName ? (
                <li className="han-archives-hero__meta-item">
                  <span className="han-archives-hero__meta-label">{leaderTitle || 'Daimyo'}</span>
                  {leaderName}
                </li>
              ) : null}
            </ul>
          )}

          {taglineHtml ? (
            <div
              className="han-archives-hero__tagline"
              dangerouslySetInnerHTML={{ __html: taglineHtml }}
            />
          ) : null}
        </div>
      </div>

      {hasBanner ? <div className="han-archives-hero__bottom-line" aria-hidden="true" /> : null}
    </header>
  )
}
